import {inject, injectable} from "inversify";
import {action, makeAutoObservable, observable, runInAction} from "mobx";
import {GameLevelStatus, GameLevel} from "data/enums";
import {Bindings} from "data/constants/bindings";
import type {IGameBarApiProvider} from "data/providers/api/gamebar.api.provider";

export interface ILastRoundInfo {
	points: number;
	rank: number;
	level: GameLevel;
	levelStatus: GameLevelStatus;
}

export interface IPromotionStore {
	get isModalViewed(): boolean;

	get roundInfo(): ILastRoundInfo | undefined;

	fetchLastCompleteRoundInfo(): Promise<void>;

	promotionViewed(): Promise<void>;
}

@injectable()
export class PromotionStore implements IPromotionStore {
	@observable private _roundInfo: ILastRoundInfo | undefined;

	constructor(
		@inject(Bindings.GameBarApiProvider) private _gameBarApiProvider: IGameBarApiProvider
	) {
		makeAutoObservable(this);
	}

	get roundInfo(): ILastRoundInfo | undefined {
		return this._roundInfo;
	}

	get isModalViewed(): boolean {
		return false;
	}

	@action
	public async fetchLastCompleteRoundInfo() {
		const {data} = await this._gameBarApiProvider.lastCompleteRoundInfo();

		runInAction(() => {
			this._roundInfo = data.success.roundRanking;
		});
	}

	@action
	public async promotionViewed() {
		await this._gameBarApiProvider.promotionViewed();
	}
}
